<ion-app [class.ion-palette-dark]="configService.config().darkMode">
  <ion-router-outlet id="main-content"></ion-router-outlet>
</ion-app>
